import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import { useFormikContext } from 'formik';

export interface submitButtonProps extends ButtonProps {
  alwaysEnabled?: boolean;
  children: string;
}

export const SubmitButton = ({
  alwaysEnabled,
  ...props
}: submitButtonProps) => {
  const { isSubmitting, isValid } = useFormikContext();

  const disabled = !alwaysEnabled && !isValid;

  if (isSubmitting) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress size="large" />
      </Box>
    );
  }

  return (
    <Button
      data-testid="submit-button"
      variant="contained"
      color="primary"
      fullWidth
      type="submit"
      size="large"
      disabled={disabled}
      aria-label={props.children}
      {...props}
    >
      {props.children}
    </Button>
  );
};
